export default __webpack_public_path__ + "static/media/testamonialAvatar3.9410abd7.png";